import React from 'react';

const PrivacyPolicy = () => {
  return <div>hello world</div>;
};

export default PrivacyPolicy;
